function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
import fetch from '@/utils/fetch';
var PULISH_PATH = '/api/v1/manager/';

// 登录 /account/login-in
export function login(data) {
  return fetch({
    url: PULISH_PATH + 'login-in',
    method: 'POST',
    data: _objectSpread({}, data)
  });
}

// 退出 /api/v1/account/logout
export function logout() {
  return fetch({
    url: PULISH_PATH + 'logout',
    method: 'POST'
  });
}

// 忘记密码
export function forgotPassword(data) {
  return fetch({
    url: PULISH_PATH + 'forgot',
    method: 'POST',
    data: data
  });
}

// 重置密码
export function resetPassword(data) {
  return fetch({
    url: PULISH_PATH + 'reset',
    method: 'POST',
    data: data
  });
}

// 我的账户信息 /api/v1/account/my
export function getMyAccount() {
  return fetch({
    url: PULISH_PATH + 'my',
    method: 'POST'
  });
}